import { useFormik } from "formik";
import * as yup from "yup";

// // Call validataion If passed then call onSubmit
// const formValidation = (values) => {
//   const errors = {};
//   console.log("formValidation", values);
//   // add validation email min 5 chars
//   if (values.email.length < 5) {
//     errors.email = "Please enter a longer email";
//   } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.email)) {
//     errors.email = "Please enter a valid email";
//   }

//   // add validation email pattern

//   if (values.password.length < 8) {
//     errors.password = "Please enter a longer password";
//   } else if (values.password.length > 12) {
//     errors.password = "Please enter a shorter password";
//   }

//   // add validation password max 12 chars

//   console.log(errors);
//   return errors;
// };

// export function BasicForm() {
//   const formik = useFormik({
//     initialValues: { email: "", password: "" },
//     validate: formValidation,
//     onSubmit: (values) => {
//       console.log("onSubmit", values);
//     },
//   });
//   return (
//     <form onSubmit={formik.handleSubmit}>
//       <input
//         id="email"
//         name="email"
//         value={formik.values.email}
//         onChange={formik.handleChange}
//         onBlur={formik.handleBlur}
//         type="email"
//         placeholder="Please enter your email"
//       />
//       {/* We should show errors only when they touch form & come outside */}
//       {formik.errors.email && formik.touched.email ? formik.errors.email : ""}
//       <input
//         id="password"
//         name="password"
//         value={formik.values.password}
//         onChange={formik.handleChange}
//         onBlur={formik.handleBlur}
//         type="password"
//         placeholder="Please enter your password"
//       />
//       {formik.errors.password && formik.touched.password
//         ? formik.errors.password
//         : ""}
//       <button type="submit">Submit</button>
//     </form>
//   );
// }

// Call validataion If passed then call onSubmit
const formValidation = (values) => {
  const errors = {};
  console.log("formValidation", values);
  // add validation email min 5 chars
  if (values.email.length < 5) {
    errors.email = "Please enter a longer email";
  } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.email)) {
    errors.email = "Please enter a valid email";
  }

  // add validation email pattern

  if (values.password.length < 8) {
    errors.password = "Please enter a longer password";
  } else if (values.password.length > 12) {
    errors.password = "Please enter a shorter password";
  }

  // add validation password max 12 chars

  console.log(errors);
  return errors;
};

const formValidationSchema = yup.object({
  email: yup
    .string()
    .min(5, "Need a bigger email 😄")
    .matches(
      /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
      "Pattern not matched 😑"
    )
    .required("Why not fill this email? 😉"),
  password: yup
    .string()
    .min(8, "Need a longer password 😄")
    .max(12, "Too much password 😅")
    .required("Why not fill this password? 😉"),
});

export function BasicForm() {
  const { handleSubmit, values, handleChange, handleBlur, errors, touched } =
    useFormik({
      initialValues: { email: "", password: "" },
      //   validate: formValidation,
      validationSchema: formValidationSchema,
      onSubmit: (values) => {
        console.log("onSubmit", values);
      },
    });
  return (
    <form onSubmit={handleSubmit}>
      <input
        id="email"
        name="email"
        value={values.email}
        onChange={handleChange}
        onBlur={handleBlur}
        type="email"
        placeholder="Please enter your email"
      />
      {/* We should show errors only when they touch form & come outside */}
      {errors.email && touched.email ? errors.email : ""}
      <input
        id="password"
        name="password"
        value={values.password}
        onChange={handleChange}
        onBlur={handleBlur}
        type="password"
        placeholder="Please enter your password"
      />
      {errors.password && touched.password ? errors.password : ""}
      <button type="submit">Submit</button>
    </form>
  );
}

// Task
// Validation - on Add movie & Edit movies
// name - required
// poster - min 4, required
// rating - 0 - 10, required
// summary - min 20 chars, required
// trailer -min 4, required
